import { denyReview } from './deny-review.service'
import { grantReview } from './grant-review.service'

export const reviewDecisionService = {
  grant: grantReview,
  deny: denyReview
}
